var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-skeleton-wrapper',{style:({ borderRadius: _vm.borderRadius }),attrs:{"loading":_vm.loading},scopedSlots:_vm._u([{key:"default",fn:function(){return [_vm._t("default")]},proxy:true},{key:"loading",fn:function(){return [_c('b-skeleton-img',{attrs:{"no-aspect":""}})]},proxy:true}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }